import React from 'react';
import Nav from '../../components/Nav';
import Footer from '../../components/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col pt-14 sm:pt-16">
      <Nav />
      <main className="flex-1 max-w-5xl mx-auto px-3 sm:px-6 lg:px-8 py-3 sm:py-5 w-full space-y-3.5 sm:space-y-5">
        
        {/* Compact Hero Banner */}
        <div className="bg-gradient-to-r from-emerald-800 via-teal-900 to-emerald-900 rounded-xl sm:rounded-2xl p-3.5 sm:py-4 sm:px-6 text-white text-center space-y-1 shadow-xs">
          <span className="bg-emerald-500/30 text-emerald-300 border border-emerald-400/40 text-[9px] font-extrabold px-2 py-0.5 rounded-full uppercase tracking-wider">
            Privacy & Protection
          </span>
          <h1 className="text-sm sm:text-lg md:text-xl font-black leading-snug">Privacy Policy</h1>
          <p className="text-emerald-100/90 text-[11px] sm:text-xs max-w-xl mx-auto">
            Last Updated: August 26, 2026
          </p>
        </div>

        <div className="bg-white p-4 sm:p-6 rounded-xl sm:rounded-2xl border border-gray-100 shadow-2xs space-y-3 sm:space-y-4 text-xs sm:text-sm text-gray-600 leading-normal">
          <section className="space-y-1">
            <h2 className="text-xs sm:text-base font-bold text-gray-900">1. Information We Collect</h2>
            <p className="text-[11px] sm:text-xs">We collect information you provide directly to us when creating an account, enrolling in courses, or contacting support (e.g., Name, Email, Mobile Number, payment transaction IDs).</p>
          </section>

          <section className="space-y-1">
            <h2 className="text-xs sm:text-base font-bold text-gray-900">2. How We Use Your Data</h2>
            <p className="text-[11px] sm:text-xs">Your personal information is used exclusively to process course enrollments, issue certificates, deliver course updates, and provide customer support.</p>
          </section>

          <section className="space-y-1">
            <h2 className="text-xs sm:text-base font-bold text-gray-900">3. Payment & Security</h2>
            <p className="text-[11px] sm:text-xs">All financial transactions are processed securely using PCI-DSS compliant payment gateways (Cashfree / UPI). E-Learning Hub does not store bank or card credentials on our servers.</p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
